import moment from 'moment';

const keyName = 'last_login';

const storage = localStorage;

type ThirdPartyLoginType = 'facebook' | 'google' | 'naver' | 'kakao';

const lastLoginTypeService = {
  get keyName(): string {
    return keyName;
  },

  getLastLoginType(): string | null {
    const lastLoginType = JSON.parse(storage.getItem(keyName) || '{}');
    if (!lastLoginType.expiry) {
      return null;
    }
    if (moment().isAfter(lastLoginType.expiry)) {
      this.removeLastLoginType();
      return null;
    }

    return lastLoginType.loginType;
  },
  setLastLoginType(loginType: ThirdPartyLoginType): void {
    storage.setItem(
      keyName,
      JSON.stringify({ loginType, expiry: moment().add(3, 'months').toISOString() })
    );
  },

  removeLastLoginType(): void {
    storage.removeItem(keyName);
  },
};

export default lastLoginTypeService;
